import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { FilterTable } from 'src/app/models/filter-table';
import { GiftCardFilter } from 'src/app/models/filters/giftcard-filter';
import { GiftCard } from 'src/app/models/giftcard';
import { Paging } from 'src/app/models/page';
import { GiftCardService } from 'src/app/services/giftcard.service';

@Component({
  selector: 'app-giftcard-list',
  templateUrl: './giftcard-list.component.html',
  styleUrls: ['./giftcard-list.component.sass']
})
export class GiftcardListComponent implements OnInit {


  giftcards: Paging<Array<GiftCard>> = new Paging([]);
  constructor(private giftCardService: GiftCardService, private router: Router, private floatingService: PosFloatingActionButtonService) {
    this.floatingService.setShow(false);
    this.floatingService.addItems();
  }

  async ngOnInit(): Promise<void> {
    await this.getGiftCards({ page: 0, pageSize: 20, value: {} });
  }

  async getGiftCards(filters: Filter<GiftCardFilter>) {
    this.giftcards = (await this.giftCardService.readGiftCards(filters).toPromise()).response;
  }

  getHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("giftCardNumber", "Número de tarjeta"),
      new ColumnTable("invoiceNumber", "Factura"),
      new ColumnTable("receiptCode", "Recibo"),
      new ColumnTable("creditNoteNumber", "Nota de Crédito"),
      new ColumnTable("timestamp", "Fecha", { type: "date" }),
      new ColumnTable("amount", "Cantidad", { type: "currency" }),
      new ColumnTable("giftCardNumber", "Opciones", {
        type: "action", actions: [
          {
            fn: (giftCard: GiftCard) => {
              this.router.navigate(["giftcards", giftCard.giftCardNumber])
            },
            icon: "fa fa-regular fa-circle-right",
            isDisabled: false,
            tooltip: "Ver Giftcard"
          }
        ]
      })
    ];
  }

  getFilters(): Array<FilterTable> {
    return [
      new FilterTable("number", "Número de tarjeta"),
      new FilterTable("invoiceNumber", "Factura"),
      new FilterTable("creditNoteNumber", "Nota de Credito"),
      new FilterTable("start", "Fecha Inicial", { type: "date" }),
      new FilterTable("end", "Fecha Final", { type: "date" }),
    ];
  }

  addGiftCard() {
    this.router.navigate(["giftcards", "create"]);
  }
}
